export { getInitialError, isLoggedInBeforeCheck, getEmail } from './visit-portal';
